import {pinSvg as Icon__small__pinSvg} from '../Icon__small/Icon__small--pin.js';
import {pinSvg as Icon__xsmall__pinSvg} from '../Icon__xsmall/Icon__xsmall--pin.js';

export var pin = {
  name: 'pin',
  category: 'icon',
  colorable: true,
  svg: Icon__small__pinSvg,
  alt: {
    Icon__small: Icon__small__pinSvg,
    Icon__xsmall: Icon__xsmall__pinSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
